import * as React from "react";
import { Outlet } from "react-router-dom";
import GroupSearch from "../../components/groups/GroupSearch";
import { parseAppTitleFromUserRole } from "../../utils/auth";
import { useAppSelector } from "../../store";
import { formatRelative } from "date-fns";

export default function GroupIndexPage() {
  const { role } = useAppSelector((state) => state.auth);
  const { lastUpdatedAt } = useAppSelector((state) => state.uploads);

  return (
    <div className="flex flex-col min-h-full gap-4">
      <section>
        <h1 className="text-xl font-medium text-allstate-blue">{parseAppTitleFromUserRole(role)} Rate Relief</h1>
        <p>Manage groups requiring actuarial relief, rerates, and high-risk claims support</p>
        <div className="text-xs text-grey-8">
          Data last updated:  {lastUpdatedAt ? formatRelative(lastUpdatedAt, new Date()) : '...' }
        </div>
      </section>
      
      <section>
        <GroupSearch />
      </section>

      <Outlet />
    </div>
  )
}